import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { StockService } from '../../shared/services/stock.service';
import { appConfiguration } from '../../configuration/app-configuration';
import { searchQueryConfiguration, initialQueryConfiguration } from '../../configuration/search-query.configuration';
import GrainTrackingService, { EVENT_TYPE, APP_MODULE } from '../../shared/services/tracking.service';
import { useLocation } from 'react-router-dom';
import Vehicle from './Vehicle';
import { VmIcon } from '@vanmossel-ui/react';
const stockService = new StockService(appConfiguration, searchQueryConfiguration);
const initialService = new StockService(appConfiguration, initialQueryConfiguration);
var FacetTypes;
(function (FacetTypes) {
    FacetTypes["CarModel"] = "car_model";
    FacetTypes["BTWMarge"] = "btw_marge";
    FacetTypes["Nieuwvoertuig"] = "nieuw_voertuig";
    FacetTypes["Dealertitle"] = "dealer_title";
    FacetTypes["Overzichtsprijs"] = "overzichtsprijs";
    FacetTypes["Tellerstand"] = "tellerstand";
})(FacetTypes || (FacetTypes = {}));
const Overview = () => {
    const location = useLocation();
    const [results, setResults] = useState({
        facets: {
            btw_marge: [],
            car_model: [],
            nieuw_voertuig: [],
            dealer_title: [],
            overzichtsprijs: [],
            tellerstand: [],
        },
    });
    const [initialResults, setInitialResults] = useState({
        facets: {
            btw_marge: [],
            car_model: [],
            nieuw_voertuig: [],
            dealer_title: [],
            overzichtsprijs: [],
            tellerstand: [],
        },
    });
    const [vehicleResults, setVehicleResults] = useState({});
    const [totalResults, setTotalResults] = useState(0);
    const [loading, setLoading] = useState(true);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const isMounted = useRef(true);
    const [filters, setFilters] = useState({});
    useEffect(() => {
        const searchParams = new URLSearchParams();
        const rangeFilters = ['overzichtsprijs', 'tellerstand'];
        Object.entries(filters).forEach(([key, values]) => {
            const isRange = rangeFilters.includes(key);
            stockService.setFilter(key, values, isRange);
            if (isRange) {
                Object.entries(values).forEach(([subKey, value]) => {
                    if (value > 0)
                        searchParams.set([key, subKey].join(','), value.toString());
                });
            }
            else {
                if (values.length) {
                    searchParams.set(key, values.join(','));
                }
            }
        });
        if (Object.entries(filters).length) {
            const newURL = new URL(window.location.href);
            newURL.search = searchParams.toString();
            window.history.replaceState('', '', newURL.href);
        }
        sessionStorage.setItem('supplyFilter', searchParams.toString());
        getVehicles();
    }, [filters]);
    function getVehicles() {
        stockService
            .get('')
            .then((data) => {
            setVehicleResults(data.rawResults);
            setTotalResults(data.rawInfo.meta.page.total_results);
            setLoading(false);
        })
            .catch((reason) => {
            console.log('reason', reason);
        });
    }
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        let newFilters = {};
        const rangeFilters = {};
        searchParams.forEach((value, key) => {
            if (key.includes(',')) {
                const [filterKey, filterProperty] = key.split(',');
                if (!rangeFilters[filterKey])
                    rangeFilters[filterKey] = {};
                rangeFilters[filterKey][filterProperty] = parseInt(value);
                Object.keys(rangeFilters).forEach((filter) => {
                    newFilters[filter] = rangeFilters[filter];
                });
            }
            else {
                newFilters[key] = value.split(',');
            }
        });
        if (Object.keys(newFilters).length) {
            setFilters(newFilters);
        }
        GrainTrackingService.track({
            event: EVENT_TYPE.STOCK_DISPLAY,
            data: {
                applicatieModule: APP_MODULE.MAXUS,
            },
            push: () => { },
        });
        initialService.get('').then((data) => {
            setInitialResults(data.rawInfo);
        });
    }, [location.search]);
    const sortResults = (sorting) => {
        stockService.sort('', sorting).then((data) => {
            setVehicleResults(data.rawResults);
            setTotalResults(data.rawInfo.meta.page.total_results);
            setLoading(false);
        });
    };
    const onFilterChange = (e, targetType, filterValue) => {
        const filterCopy = Object.assign({}, filters);
        const filterKey = targetType;
        if (filterCopy.hasOwnProperty(targetType)) {
            const newContents = [...filterCopy[filterKey]];
            if (newContents.includes(e.target.value)) {
                newContents.splice(newContents.indexOf(e.target.value), 1);
            }
            else {
                newContents.push(e.target.value);
            }
            filterCopy[filterKey] = newContents;
        }
        else {
            filterCopy[filterKey] = [e.target.value];
        }
        setFilters(filterCopy);
    };
    const onRangeFilterChange = (e, targetType) => {
        const rangeNumber = parseInt(e.target.value);
        const filterCopy = Object.assign({}, filters);
        const filterKey = targetType;
        if (filterCopy.hasOwnProperty(targetType)) {
            const newContents = Object.assign({}, filterCopy[filterKey]);
            newContents[e.target.id] = rangeNumber;
            filterCopy[filterKey] = newContents;
        }
        else {
            filterCopy[filterKey] = { [e.target.id]: rangeNumber };
        }
        setFilters(filterCopy);
    };
    const filtermenuTrigger = () => {
        setFilterMenuOpen(!filterMenuOpen);
    };
    const onSortChange = (e) => {
        sortResults(e.target.value);
    };
    const isSet = (facet, value) => {
        var _a;
        return (_a = filters[facet]) === null || _a === void 0 ? void 0 : _a.includes(value);
    };
    const getDefault = (facet) => {
        var _a, _b, _c, _d;
        const newFrom = (_b = (_a = filters[facet]) === null || _a === void 0 ? void 0 : _a.from) !== null && _b !== void 0 ? _b : 0;
        const newTo = (_d = (_c = filters[facet]) === null || _c === void 0 ? void 0 : _c.to) !== null && _d !== void 0 ? _d : 0;
        return {
            defaultFrom: newFrom,
            defaultTo: newTo,
        };
    };
    return (_jsxs("div", { className: "stock-overview", children: [_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-lg-3", children: _jsx("h1", { className: "mb-3", children: "Voorraad" }) }), _jsx("div", { className: "col-lg-9", children: _jsxs("div", { className: "stock-top-info", children: [_jsxs("h5", { children: [totalResults, " ", totalResults !== 1 ? 'resultaten' : 'resultaat'] }), _jsxs("div", { className: "stock-sorting", children: [_jsxs("select", { onChange: onSortChange, children: [_jsx("option", { value: "created:desc", children: "Nieuwste eerst" }, "created-desc"), _jsx("option", { value: "created:asc", children: "Oudste eerst" }, "created-asc"), _jsx("option", { value: "overzichtsprijs:asc", children: "Laagste prijs" }, "price-asc"), _jsx("option", { value: "overzichtsprijs:desc", children: "Hoogste prijs" }, "price-desc"), _jsx("option", { value: "tellerstand:asc", children: "Laagste kilometerstand" }, "km-asc"), _jsx("option", { value: "tellerstand:desc", children: "Hoogste kilometerstand" }, "km-desc")] }), _jsx(VmIcon, { icon: "bars-arrow-down" })] })] }) })] }), _jsxs("div", { className: "row", children: [_jsxs("div", { className: `stock-filter__container col-lg-3 ${filterMenuOpen ? 'is-open' : ''}`, children: [_jsx("button", { onClick: filtermenuTrigger, className: "hidden stock-filter__closetrigger" }), loading ? (_jsx("p", { children: "Loading..." })) : (Object.keys(initialResults.facets).map((facet, i) => {
                                var _a;
                                const facetType = facet;
                                const hasItems = initialResults.facets[facetType].length > 0;
                                if (!hasItems)
                                    return;
                                const facetConfig = initialResults.facets[facetType][0];
                                if (facetConfig.name === 'vestiging') {
                                    facetConfig.data = (_a = facetConfig.data) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
                                        return a.value.localeCompare(b.value);
                                    });
                                }
                                if (facetConfig.type === 'value' && facetConfig.data) {
                                    const facetName = facetConfig.name;
                                    const name = facetName === 'model'
                                        ? 'Model'
                                        : facetName === 'vestiging'
                                            ? 'Vestiging'
                                            : facetName === 'nieuwgebruikt'
                                                ? 'Nieuw/Gebruikt'
                                                : facetName === 'btwmarge'
                                                    ? 'BTW/Marge'
                                                    : facetName;
                                    return (_jsxs("div", { className: "stock-filter", children: [_jsx("h5", { className: "stock-filter__label", children: name }), facetConfig.data.map((facetdata, index) => {
                                                const uniqueKey = `key_${facetdata.value}_${index}`.replace(/ /g, '').toLowerCase();
                                                let label = facetdata.value;
                                                label = label === 'n' ? 'Gebruikt' : label;
                                                label = label === 'j' ? 'Nieuw' : label;
                                                label = label === 'B' ? 'BTW' : label;
                                                label = label === 'M' ? 'Marge' : label;
                                                if (label === '')
                                                    return null;
                                                return (_jsxs("div", { className: "stock-filter__item", children: [_jsx("input", { id: uniqueKey, value: facetdata.value, checked: isSet(facet, facetdata.value), type: "checkbox", onChange: (event) => onFilterChange(event, facetType, event.target.checked) }), _jsx("label", { htmlFor: uniqueKey, children: label })] }, uniqueKey));
                                            })] }, i));
                                }
                                else if (facetConfig.type === 'range' && facetConfig.data) {
                                    const facetName = facetConfig.name;
                                    const { defaultFrom, defaultTo } = getDefault(facet);
                                    const uniqueKey = `key_${facetName}_${i}`.replace(/ /g, '').toLowerCase();
                                    return (_jsxs("div", { className: "stock-filter stock-filter--range", children: [_jsx("h5", { className: "stock-filter__label", children: facetName }), facetConfig.data.map((_, index) => {
                                                const uniqueKey = `key_${facetType}_${index}`.replace(/ /g, '').toLowerCase();
                                                return (_jsxs("div", { children: [_jsx("div", { className: "stock-filter__item", children: _jsxs("label", { htmlFor: "from", children: [_jsx("span", { children: "Van" }), _jsxs("select", { id: "from", onChange: (event) => onRangeFilterChange(event, facetType), defaultValue: defaultFrom, children: [_jsx("option", { value: "0", children: "Geen minimum" }), Array.from({ length: 20 }, (_, i) => (i + 1) * 5000).map((value, i) => (_jsx("option", { value: value, children: new Intl.NumberFormat('nl-NL').format(value) }, i + value)))] })] }) }), _jsx("div", { className: "stock-filter__item", children: _jsxs("label", { htmlFor: "to", children: [_jsx("span", { children: "Tot" }), _jsxs("select", { id: "to", onChange: (event) => onRangeFilterChange(event, facetType), defaultValue: defaultTo, children: [_jsx("option", { value: "0", children: "Geen maximum" }), Array.from({ length: 20 }, (_, i) => (i + 1) * 5000).map((value, i) => (_jsx("option", { value: value, children: new Intl.NumberFormat('nl-NL').format(value) }, value + i)))] })] }) })] }, uniqueKey));
                                            })] }, uniqueKey));
                                }
                                return null;
                            })), _jsx("div", { className: "hidden stock-vehicles__button-bar", children: _jsxs("button", { onClick: filtermenuTrigger, className: "button button--primary button--quotation", children: [_jsx(VmIcon, { icon: "adjustments-vertical" }), filterMenuOpen ? `Bekijk ${totalResults} resultaten` : 'Filter resultaten'] }) })] }), _jsx("div", { className: "stock-vehicles col-lg-9", children: _jsx("div", { className: "row", children: loading ? (_jsx("p", { children: "Loading..." })) : Object.keys(vehicleResults).length > 0 ? (Object.values(vehicleResults).map((vehicle, index) => (_jsx(Vehicle, { vehicle: vehicle }, index)))) : (_jsx("p", { children: "Geen voertuigen gevonden met de geselecteerde filters." })) }) })] })] }));
};
export default Overview;
